import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import { Modal } from 'antd';
import GalleryList from '../components/gallery/GalleryList';
import GalleryBulkUpload from '../components/gallery/GalleryBulkUpload';
import PageHeader from '../components/common/PageHeader';
import { CollectionsOutlined as GalleryIcon } from '@mui/icons-material';

const GalleryPage = () => {
  const listRef = useRef();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isBulkModalVisible, setIsBulkModalVisible] = useState(false);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsBulkModalVisible(true);
  };

  const handleSuccess = () => {
    setSelectedItem(null);
    setIsBulkModalVisible(false);
    listRef.current?.refresh();
  };

  return (
    <Box className="premium-container">
      <PageHeader
        title="Media Gallery"
        subtitle="Manage images and media assets categorized by events and folders."
        titleIcon={<GalleryIcon />}
        btnText="ADD FOLDER"
        onBtnClick={() => {
          setSelectedItem(null);
          setIsBulkModalVisible(true);
        }}
      />

      <Box className="premium-table-card">
        <GalleryList ref={listRef} onEdit={handleEdit} />
      </Box>

      <Modal
        width={1000}
        footer={null}
        style={{ top: 20 }}
        open={isBulkModalVisible}
        onCancel={() => { 
          setIsBulkModalVisible(false);
          setSelectedItem(null);
        }}
        title={selectedItem ? "Edit Folder" : "Add Folder"}
      >
        <GalleryBulkUpload
          onSuccess={handleSuccess}
          onCancel={() => {
            setIsBulkModalVisible(false);
            setSelectedItem(null);
          }}
          initialValues={isBulkModalVisible ? selectedItem : null}
        />
      </Modal>
    </Box>
  );
};

export default GalleryPage;
